import { useTranslate } from '@refinedev/core';
import { Space, theme } from 'antd';
import type { PublicationListOut } from '@/api/generated/schemas';
import { StatusDotTag } from '@/components/common/StatusDotTag';
import { statusTone } from '@/components/common/statusTone';
import { publicationFormatStatuses } from './publicationFacts';

/** Moderation state at all three levels: the publication and each of its
 * two formats. Plain statements — no consumer-specific judgement. */
export const PublicationStatusTags = ({
  publication,
}: {
  publication: PublicationListOut;
}) => {
  const t = useTranslate();
  const { token } = theme.useToken();

  return (
    <Space size={token.marginXXS} wrap>
      <StatusDotTag
        label={t('user_catalog.common.publications_editor.publication')}
        status={t(`user_catalog.common.status.${publication.mod_status}`)}
        tone={statusTone(publication.mod_status)}
      />
      {/* An absent format says nothing worth a tag. */}
      {publicationFormatStatuses(publication)
        .filter(({ modStatus }) => modStatus != null)
        .map(({ format, modStatus }) => (
          <StatusDotTag
            key={format}
            label={t(`user_catalog.common.formats.${format}`)}
            status={t(`user_catalog.common.status.${modStatus}`)}
            tone={statusTone(modStatus)}
          />
        ))}
    </Space>
  );
};
